import { call, put, select } from 'redux-saga/effects';
import { iActionList } from '~/domain/interfaces/redux/diagnosisReport/list';
import { ListDiagnosisReport } from '~/domain/usecases/diagnosisReport/remote/ListDiagnosisReport';
import { makeRemoteListDiagnosisReport } from '~/main/factories/usecases/diagnosisReport/ListDiagnosisReportFactory';
import {
  listSuccess,
  listFailed,
} from '~/data/store/reducer/diagnosisReport/actions/list';

export function* onList(action: iActionList) {
  const remoteListDiagnosisReport = makeRemoteListDiagnosisReport();

  try {
    const response: ListDiagnosisReport.Model = yield call(
      remoteListDiagnosisReport.list,
      action.payload,
    );
    yield put(
      listSuccess({
        ...response,
      }),
    );
  } catch (e) {
    yield put(listFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onListSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onListFailed() {}
